<!--阅读拓展馆-->
<template>
    <div class="read_nav_content">
        <!-- 阅读拓展首页 -->
        <div class="read-ext-container" v-show="showMode==='homePage'">
            <div class="museum-title-container">
                <div class="l-museum-title-container">
                    <div class="l-t-museum-title-container">恒岳·劳动实践营</div>
                    <div class="l-b-museum-title-container">习得劳动技能 培养责任担当</div>
                </div>
                <div class="r-museum-title-container">
                    <div v-show="this.isShowBack" class="back-btn-container" @click="backMuseum" >⇦返回</div>
                </div>

            </div>
            <div class="museum-item-container">
                <div class="labor-museum-item-line-container">
                    <div class="museum-item-top-container" v-for="item in itemList.slice(0,3)" :key="item.itemId">
                        <div class="labor-museum-item-top">
                            <div class="museum-item-content">
                                <div class="museum-item-40 mf1">{{item.itemMonth}} {{item.itemName}}</div>
                                <div class="museum-item-20 labor-mf2">{{item.itemDesc}}</div>
                                <div class="museum-item-40 dis-align">
                                    <div class="resource-btn" @click="viewActivityPage(item)">查看资源</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 第二行  -->
                <div class="labor2-museum-item-line-container">
                    <div class="museum-item-top2-container" v-for="item in itemList.slice(3,6)" :key="item.itemId">
                        <div class="labor2-museum-item-top">
                            <div class="museum-item-content">
                                <div class="museum-item-40 mf1">{{item.itemMonth}} {{item.itemName}}</div>
                                <div class="museum-item-20 labor-mf2">{{item.itemDesc}}</div>
                                <div class="museum-item-40 dis-align">
                                    <div class="resource-btn" @click="viewActivityPage(item)">查看资源</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="labor-museum-item-bottom-container">
                    <div class="labor-museum-item-bottom-outside">
                        <div class="museum-item-bottom-inside">
                            <div class="museum-item-bottom-inside-l">
                                <div class="museum-item-60 mf1">四季劳动主题活动</div>
                                <div class="museum-item-40 mf2">四季耕读、劳动砺心</div>
                            </div>
                            <div class="museum-item-bottom-inside-r dis-align">
                                <div class="inside-r-btn" @click="viewPageEvent('劳动实践主题班会','4')">查看线下活动</div>
                                <div class="inside-r-btn" @click="viewExcursion()">研学设计</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <!--劳动实践活动列表-->
        <div class="labor-activity-container" v-show="showMode==='activityPage'">
            <museum-activity-page :item-info="currentItem"
                                museum-key="4"
                                :mark-info="markInfo"
                                @back-page="backModelPage"
                                @view-info="viewActivityInfo"/>
        </div>

        <!--劳动实践活动详情-->
        <div class="labor-activity-container" v-show="showMode==='activityInfo'">
            <museum-activity-info :activity-id="activityId"
                                :mark-info="markInfo"
                                @back-page="backActivityPage"/>
        </div>

        <!--研学实践-->
        <div class="read_nav_content" v-show="showMode==='museumEventPage'">
            <labor-event-club :museum-id="this.museumId"
                               :mark-info="this.markInfo"
                               @back-read-museum="backModelPage"/>
        </div>

        <!--研学设计列表-->
        <div class="read_nav_content" v-show="showMode==='excursionPage'">
            <excursion-list :mark-info="markInfo"
                            camp-key="4"
                            @back-page="backModelPage"
                            @view-info="viewExcursionInfo"/>
        </div>

        <!--研学设计详情-->
        <div class="read_nav_content" v-show="showMode==='excursionInfo'">
            <excursion-info :excursion-id="excursionId"
                            @back-page="backExcursionPage"/>
        </div>

    </div>
</template>

<script>
import {serviceUrl} from "@/utils/global";
import {listItem} from "@/api/admin/museum";
import beautyEdu from "@/components/newMuseum/bymy/beautyEdu.vue";
import pageMuseumEvent from "@/components/newMuseum/event/pageMuseumEvent.vue";
import practiceHome from "@/components/newMuseum/practice/practiceHome.vue";
import laborEventClub from "@/components/museumEvent/laborEventClub.vue";
import museumActivityPage from "@/components/museumEvent/museumActivityPage.vue";
import museumActivityInfo from "@/components/museumEvent/museumActivityInfo.vue";
import excursionList from "@/components/newMuseum/excursion/excursionList.vue";
import excursionInfo from "@/components/newMuseum/excursion/excursionInfo.vue";

export default {
    name: "laborPracticeMuseum",
    components: {laborEventClub, pageMuseumEvent, beautyEdu,practiceHome, museumActivityPage, museumActivityInfo, excursionList, excursionInfo},
    data() {
        return {
            showMode:'homePage',
            baseMode:'model-',
            serviceUrl,
            itemId:'',
            itemName:'恒岳科创会',
            markInfo:'museumEventPage',
            museumMode:"",
            museumId:"",
            itemKey:"",
            itemList:[],
            currentItem:{},
            activityId:'',
            excursionId:'',
            queryItemForm:{
                itemType:'5',
                museumKey:'4',
            },
        }
    },
    computed: {},
    props:{
        isShowBack:{
            type: Boolean,
            default:true
        },
    },
    watch: {
        isShowBack(newValue,oldValue){
        },
    },
    created() {
        this.queryItemList();
    },
    mounted(){},
    methods: {
        /*查询年级模块列表*/
        queryItemList(){
            listItem(this.queryItemForm).then(res => {
                if (res.data.code === 1) {
                    this.itemList = res.data.data || [];
                }else {
                    this.$message.error(res.data.msg || "请求出错")
                }
            })
        },
        backModelPage(val){
            this.showMode = "homePage";
        },
        viewPageEvent(title,key){
            this.markInfo = new Date();
            this.museumId = '4';
            this.showMode = 'museumEventPage';
        },
        /*研学设计*/
        viewExcursion(){
            this.markInfo = new Date() + '';
            this.showMode = 'excursionPage';
        },
        /*查看专属研学详情*/
        viewExcursionInfo(item){
            this.excursionId = item.excursionId;
            this.showMode = 'excursionInfo';
        },
        /*返回专属研学列表*/
        backExcursionPage(){
            this.showMode = 'excursionPage';
        },
        /*查看年级模块活动列表*/
        viewActivityPage(item){
            this.currentItem = item;
            this.markInfo = new Date() + '';
            this.showMode = 'activityPage';
        },
        /*查看线下活动详情*/
        viewActivityInfo(item){
            this.activityId = item.activityId;
            this.markInfo = new Date() + '';
            this.showMode = 'activityInfo';
        },
        backActivityPage(){
            this.showMode = 'activityPage';
        },
        /*返回五馆首页*/
        backMuseum(){
            this.$emit('child-back-museum', "page");
        },
        /*查看阅读馆模块*/
        viewReadModel(val){
            this.markInfo = 'time-'+new Date();
            this.showMode =  this.baseMode+val;
        },
        /*从子模块阅读馆*/
        backReadMuseum(val){
            this.showMode = val;
        }
    }
}
</script>
<style scoped>
.read_nav_content{
    width: 100%;
    height: auto;
}
.labor-activity-container{
    width: 100%;
    height: calc(100vh - 174px);
    background: #ffffff;
    border-radius: 16px;
}
/* 外层容器：白色圆角卡片，高度固定一屏，参照 readExtensionMuseum */
.read-ext-container{
    width: 100%;
    height: calc(100vh - 174px);
    background: #ffffff;
    border-radius: 16px;
    padding: 20px 0;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
}

.museum-title-container{
    flex-shrink: 0;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 14px;
}
.l-museum-title-container{
    display: flex;
    flex-direction: column;
    gap: 4px;
}
.l-t-museum-title-container{
    font-weight: bold;
    color: #0d55a4;
    font-size: 18px;
    line-height: 1.4;
}
.l-b-museum-title-container{
    color: #9a9a9a;
    font-size: 14px;
}
.r-museum-title-container{
    display: flex;
    align-items: center;
}
.back-btn-container{
    height: 32px;
    padding: 0 14px;
    background: #0d55a4;
    color: #fff;
    line-height: 32px;
    text-align: center;
    font-size: 14px;
    border-radius: 6px;
    cursor: pointer;
}

.museum-item-container{
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 0 28px;
    box-sizing: border-box;
}
.labor-museum-item-line-container{
    flex-shrink: 0;
    width: 100%;
    height: 45%;
    display: flex;
    gap: 20px;
}
.labor2-museum-item-line-container{
    flex-shrink: 0;
    width: 100%;
    height: 45%;
    display: flex;
    gap: 20px;
}
.museum-item-top-container{
    width: calc((100% - 40px) / 3);
    height: 100%;
    display: flex;
    align-items: center;
    justify-items: center;
}
.museum-item-top2-container{
    width: calc((100% - 40px) / 3);
    height: 100%;
    display: flex;
    align-items: center;
    justify-items: center;
}
.labor-museum-item-top{
    width: 100%;
    height: 85%;
    border-left: 5px solid #0d55a4;
    box-shadow: inset 0 0 2px rgba(0,0,0,0.22);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
}
.labor2-museum-item-top{
    width: 100%;
    height: 85%;
    border-left: 5px solid #0d55a4;
    box-shadow: inset 0 0 2px rgba(0,0,0,0.22);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
}
.museum-item-content{
    width: 90%;
    height: 80%;
}
.museum-item-40{
    width: 100%;
    height: 40%;
}
.museum-item-60{
    width: 100%;
    height: 60%;
}
.mf1{
    color: #0d55a4;
    font-weight: bold;
    display: flex;
    align-items: center;
    font-size: clamp(16px, 12cqh, 18px);
}
.labor-mf2{
    color: #9a9a9a;
    font-size: 13px;
}

.museum-item-20{
    width: 100%;
    height: 20%;
}
.resource-btn{
    width: 100%;
    height: 70%;
    background: #0d55a4;
    color: #fff;
    font-size: 15px;
    font-weight: 700;
    border-radius: 6px;
    /* 核心居中代码 */
    display: flex;
    /* 水平居中 */
    justify-content: center;
    /* 垂直居中 */
    align-items: center;
    cursor: pointer;
}
.dis-align{
    display: flex;
    justify-items: center;
    align-items: center;
}

.labor-museum-item-bottom-container{
    flex-shrink: 0;
    width: 100%;
    height: 50%;
}
.labor-museum-item-bottom-outside{
    width: 100%;
    height: 70%;
    border: 3px solid #0d55a4;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
}
.museum-item-bottom-inside{
    width: 99%;
    height: 92%;
    border: 1px solid #e99d42;
    padding: 10px 20px 10px 20px;
    box-sizing: border-box;
    display: flex;
}

.museum-item-bottom-inside-l{
    width: calc(100% - 260px);
    height: 100%;
}
.museum-item-bottom-inside-r{
    width: 260px;
    height: 100%;
    gap: 10px;
}
.inside-r-btn{
    flex: 1;
    min-width: 0;
    height: 38%;
    background: #0d55a4;
    color: #fff;
    font-size: 15px;
    font-weight: 700;
    border-radius: 6px;
    /* 核心居中代码 */
    display: flex;
    /* 水平居中 */
    justify-content: center;
    /* 垂直居中 */
    align-items: center;
    cursor: pointer;
}

</style>